import React, { useState, useEffect } from 'react';
import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import { useAuth } from '../context/AuthContext';
import { FiUsers, FiUserPlus, FiSearch, FiArrowUp, FiArrowDown } from 'react-icons/fi';

export default function Customers() {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sortField, setSortField] = useState('name');
  const [sortDirection, setSortDirection] = useState('asc');
  const { selectedHierarchy } = useAuth();

  useEffect(() => {
    loadCustomers();
  }, [selectedHierarchy]);

  const loadCustomers = async () => {
    if (!selectedHierarchy?.outlet?.id) return;
    try {
      const customersQuery = query(
        collection(db, 'customers'),
        where('outletId', '==', selectedHierarchy.outlet.id)
      );
      const snapshot = await getDocs(customersQuery);
      setCustomers(snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));
    } catch (error) {
      console.error('Error loading customers:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'asc' ? 'desc' : 'asc');
    } else {
      setSortField(field);
      setSortDirection('asc');
    }
  };

  const sortedCustomers = [...customers].sort((a, b) => {
    let aVal, bVal;
    
    if (sortField === 'name') {
      aVal = (a.name || '').toLowerCase();
      bVal = (b.name || '').toLowerCase();
    } else if (sortField === 'email') {
      aVal = (a.email || '').toLowerCase();
      bVal = (b.email || '').toLowerCase();
    } else if (sortField === 'phone') {
      aVal = (a.phone || '').toLowerCase();
      bVal = (b.phone || '').toLowerCase();
    }
    
    if (aVal < bVal) return sortDirection === 'asc' ? -1 : 1;
    if (aVal > bVal) return sortDirection === 'asc' ? 1 : -1;
    return 0;
  });

  return (
    <div className="container-fluid">
      <div className="page-header mb-4">
        <h1 className="page-title">Customers</h1>
        <p className="page-subtitle">Manage customer information</p>
      </div>

      <div className="card hover-lift">
        <div className="card-header d-flex justify-content-between align-items-center">
          <h5 className="mb-0">Customers</h5>
          <button className="btn btn-sm btn-primary">
            <FiUserPlus className="me-2" /> Add Customer
          </button>
        </div>

        <div className="card-body">
          {loading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary"></div>
              <p className="text-muted mt-2">Loading customers...</p>
            </div>
          ) : customers.length === 0 ? (
            <div className="text-center py-5">
              <FiUsers size={48} className="text-muted mb-3" />
              <p className="text-muted mb-0">No customers found</p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th 
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleSort('name')}
                    >
                      Name
                      {sortField === 'name' && (
                        sortDirection === 'asc' ? <FiArrowUp className="ms-1" /> : <FiArrowDown className="ms-1" />
                      )}
                    </th>
                    <th 
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleSort('email')}
                    >
                      Email
                      {sortField === 'email' && (
                        sortDirection === 'asc' ? <FiArrowUp className="ms-1" /> : <FiArrowDown className="ms-1" />
                      )}
                    </th>
                    <th 
                      style={{ cursor: 'pointer' }}
                      onClick={() => handleSort('phone')}
                    >
                      Phone
                      {sortField === 'phone' && (
                        sortDirection === 'asc' ? <FiArrowUp className="ms-1" /> : <FiArrowDown className="ms-1" />
                      )}
                    </th>
                    <th>Orders</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {sortedCustomers.map(customer => (
                    <tr key={customer.id}>
                      <td>{customer.name}</td>
                      <td>{customer.email || '-'}</td>
                      <td>{customer.phone || '-'}</td>
                      <td><span className="badge bg-primary">{customer.orderCount || 0}</span></td>
                      <td>
                        <button className="btn btn-sm btn-outline-primary">View</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
